import axios from '../utils/axios';
import Constants from './types';
import { getSystemConfiguration } from './systemConfig';
import { formatRealNumber, getSessionId, getPayloadFromError } from '../utils';

export const getStringComparators = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/string-comparators',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getStringComparatorsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getStringComparatorsFailure(err));
      });
  };
};

export const replaceMatchingAlgorithm = (entityId, algorithm) => {
  const sessionId = getSessionId();
  const url =
    algorithm === 'deterministic'
      ? '/openempi-ws-rest/1.0/deterministic-matching/configuration'
      : '/openempi-ws-rest/1.0/probabilistic-matching/configuration';
  return dispatch => {
    axios({
      method: 'POST',
      url: url,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(replaceMatchingAlgorithmSuccess(res.data));
        dispatch(getSystemConfiguration(entityId, sessionId));
      })
      .catch(err => {
        dispatch(replaceMatchingAlgorithmFailure(err));
      });
  };
};

export const getDeterministicMatchingConfig = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getDeterMatchConfigRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/deterministic-matching/configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getDeterMatchConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(getDeterMatchConfigFailure(err));
      });
  };
};

export const saveDeterministicMatchingConfig = (entityId, matchingConfig) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/deterministic-matching/configuration',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: matchingConfig,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getDeterministicMatchingConfig(entityId, sessionId));
        dispatch(saveDeterMatchConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveDeterMatchConfigFailure(err));
      });
  };
};

export const initializeDeterministicModel = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/deterministic-matching/model',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(initializeDeterministicModelSuccess(res.data));
      })
      .catch(err => {
        dispatch(initializeDeterministicModelFailure(err));
      });
  };
};

export const initializeProbabilisticModel = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/model',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(initializeProbabilisticModelSuccess(res.data));
      })
      .catch(err => {
        dispatch(initializeProbabilisticModelFailure(err));
      });
  };
};

export const reevaluateProbableLinks = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/record-links/probable-links',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(reevaluateProbableLinksSuccess(res.data));
      })
      .catch(err => {
        dispatch(reevaluateProbableLinksFailure(err));
      });
  };
};

export const getProbabilisticMatchingConfig = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getProbMatchConfigRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        const matchingConfig = formatValues(res.data);
        dispatch(getProbMatchConfigSuccess(matchingConfig));
        dispatch(getProbabilisticLoggedPairCounts(entityId, sessionId));
      })
      .catch(err => {
        dispatch(getProbMatchConfigFailure(err));
      });
  };
};

export const getProbabilisticLoggedPairCounts = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url:
        '/openempi-ws-rest/1.0/probabilistic-matching/configuration/logged-pair-counts',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getProbLoggedPairCountsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getProbLoggedPairCountsFailure(err));
      });
  };
};

export const saveProbabilisticMatchingConfig = (entityId, matchingConfig) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/configuration',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: matchingConfig,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getProbabilisticMatchingConfig(entityId, sessionId));
        dispatch(saveProbMatchConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveProbMatchConfigFailure(err));
      });
  };
};

export const replaceMatchingConfiguration = (entityId, sourceEntityId) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/configuration/replace',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId,
        sourceEntityId: sourceEntityId
      }
    })
      .then(res => {
        dispatch(replaceMatchingConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(replaceMatchingConfigFailure(err));
      });
  };
};

export const addFieldProbabilisticMatchingConfig = (entityId, field) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/configuration/field',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: field,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getProbabilisticMatchingConfig(entityId, sessionId));
        dispatch(addFieldProbMatchConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(addFieldProbMatchConfigFailure(err));
      });
  };
};

export const replaceFieldProbabilisticMatchingConfig = (
  entityId,
  currFieldName,
  newFieldName
) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/configuration/field',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId,
        currFieldName: currFieldName,
        newFieldName: newFieldName
      }
    })
      .then(res => {
        dispatch(getProbabilisticMatchingConfig(entityId, sessionId));
        dispatch(replaceFieldProbMatchConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(replaceFieldProbMatchConfigFailure(err));
      });
  };
};

export const deleteFieldProbabilisticMatchingConfig = (entityId, field) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/probabilistic-matching/configuration/field',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: field,
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getProbabilisticMatchingConfig(entityId, sessionId));
        dispatch(deleteFieldProbMatchConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteFieldProbMatchConfigFailure(err));
      });
  };
};

export const classifyRecordPair = (entityId, recordPair) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'GET',
      url: `/openempi-ws-rest/1.0/probabilistic-matching/classification/${recordPair[0].recordId}/${recordPair[1].recordId}`,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(classifyRecordPairSuccess(res.data));
      })
      .catch(err => {
        dispatch(classifyRecordPairFailure(err));
      });
  };
};

const formatValues = matchingConfig => {
  if (matchingConfig) {
    if (matchingConfig.vectorConfig) {
      matchingConfig.vectorConfig.forEach(
        vector => (vector.weight = formatRealNumber(vector.weight, 6))
      );
    }
    if (matchingConfig.fields) {
      matchingConfig.fields.forEach(field => {
        field.MValue = formatRealNumber(field.MValue);
        field.UValue = formatRealNumber(field.UValue);
      });
    }
    matchingConfig.PValue = formatRealNumber(matchingConfig.PValue);
    matchingConfig.loggingByVectorsFraction = formatRealNumber(
      matchingConfig.loggingByVectorsFraction,
      2
    );
    matchingConfig.loggingByWeightFraction = formatRealNumber(
      matchingConfig.loggingByWeightFraction,
      2
    );
    matchingConfig.lowerBound = formatRealNumber(matchingConfig.lowerBound);
    matchingConfig.upperBound = formatRealNumber(matchingConfig.upperBound);
  }
  return matchingConfig;
};

const getDeterMatchConfigRequest = () => {
  return {
    type: Constants.DETERMATCHCONFIG_GET_REQUEST
  };
};

const getDeterMatchConfigSuccess = data => {
  return {
    type: Constants.DETERMATCHCONFIG_GET_SUCCESS,
    payload: data
  };
};

const getDeterMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DETERMATCHCONFIG_GET_FAILURE,
    payload
  };
};

export const clearDeterMatchingError = () => {
  return {
    type: Constants.DETERMATCHCONFIG_CLEAR_ERROR
  };
};

const saveDeterMatchConfigSuccess = data => {
  return {
    type: Constants.DETERMATCHCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const saveDeterMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DETERMATCHCONFIG_SAVE_FAILURE,
    payload
  };
};

const initializeDeterministicModelSuccess = data => {
  return {
    type: Constants.DETERMODEL_INIT_SUCCESS,
    payload: data
  };
};

const initializeDeterministicModelFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.DETERMODEL_INIT_FAILURE,
    payload
  };
};

const initializeProbabilisticModelSuccess = data => {
  return {
    type: Constants.PROBMODEL_INIT_SUCCESS,
    payload: data
  };
};

const initializeProbabilisticModelFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMODEL_INIT_FAILURE,
    payload
  };
};

const reevaluateProbableLinksSuccess = data => {
  return {
    type: Constants.RECORD_LINKS_EVALPROBABLE_SUCCESS,
    payload: data
  };
};

const reevaluateProbableLinksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_LINKS_EVALPROBABLE_FAILURE,
    payload
  };
};

export const clearProbMatchingError = () => {
  return {
    type: Constants.PROBMATCHCONFIG_CLEAR_ERROR
  };
};

export const clearEvaluation = () => {
  return {
    type: Constants.PROBMATCHCONFIG_CLEAR_EVALUATION
  };
};

const getProbMatchConfigRequest = () => {
  return {
    type: Constants.PROBMATCHCONFIG_GET_REQUEST
  };
};

const getProbMatchConfigSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_GET_SUCCESS,
    payload: data
  };
};

const getProbMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_GET_FAILURE,
    payload
  };
};

const getProbLoggedPairCountsSuccess = data => {
  return {
    type: Constants.PROBLOGGEDPAIRCOUNTS_GET_SUCCESS,
    payload: data
  };
};

const getProbLoggedPairCountsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBLOGGEDPAIRCOUNTS_GET_FAILURE,
    payload
  };
};

const saveProbMatchConfigSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const saveProbMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_FAILURE,
    payload
  };
};

const replaceMatchingConfigSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_REPLACE_SUCCESS,
    payload: data
  };
};

const replaceMatchingConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_REPLACE_FAILURE,
    payload
  };
};

const addFieldProbMatchConfigSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const addFieldProbMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_FAILURE,
    payload
  };
};

const replaceFieldProbMatchConfigSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const replaceFieldProbMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_FAILURE,
    payload
  };
};

const deleteFieldProbMatchConfigSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const deleteFieldProbMatchConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_SAVE_FAILURE,
    payload
  };
};

const getStringComparatorsSuccess = data => {
  return {
    type: Constants.STRINGCOMPARATORS_GET_SUCCESS,
    payload: data
  };
};

const getStringComparatorsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.STRINGCOMPARATORS_GET_FAILURE,
    payload
  };
};

const classifyRecordPairSuccess = data => {
  return {
    type: Constants.PROBMATCHCONFIG_CLASSIFYPAIR_SUCCESS,
    payload: data
  };
};

const classifyRecordPairFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PROBMATCHCONFIG_CLASSIFYPAIR_FAILURE,
    payload
  };
};

// Currently we don't do anything with the success of the matching algorithm replacement
const replaceMatchingAlgorithmFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ENTITIES_REPLACE_MATCHING_FAILURE,
    payload
  };
};

const replaceMatchingAlgorithmSuccess = data => {
  return {
    type: Constants.ENTITIES_REPLACE_MATCHING_SUCCESS,
    payload: data
  };
};
